import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fmtSlot = (t) => t.replace(":", "h");

export function TimeSlotSelect({
  scope,
  date,
  value,
  onChange,
  hasError,
  testid,
  className = "",
  fullSlots = [],
  forceEnabled = false,
}) {
  const [slots, setSlots] = useState([]);
  const [closed, setClosed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [usage, setUsage] = useState({});
  const [autoFull, setAutoFull] = useState([]);

  useEffect(() => {
    if (scope !== "reservations" || !date) {
      setUsage({});
      setAutoFull([]);
      return;
    }
    let alive = true;
    axios
      .get(`${API}/availability/day`, { params: { date } })
      .then((r) => {
        if (!alive) return;
        const map = {};
        (r.data.services || []).forEach((s) =>
          (s.slots || []).forEach((sl) => {
            map[sl.time] = sl.used;
          })
        );
        setUsage(map);
        setAutoFull(
          (r.data.services || [])
            .filter(
              (s) => s.full || Math.max(0, r.data.capacity - s.used) === 0
            )
            .flatMap((s) => (s.slots || []).map((sl) => sl.time))
        );
      })
      .catch(() => alive && setUsage({}));
    return () => {
      alive = false;
    };
  }, [scope, date]);

  const allFull = [...new Set([...fullSlots, ...autoFull])];

  useEffect(() => {
    if (!date) {
      setSlots([]);
      setClosed(false);
      return;
    }
    let alive = true;
    setLoading(true);
    axios
      .get(`${API}/slots/${scope}`, { params: { date } })
      .then((r) => {
        if (!alive) return;
        setSlots(r.data.slots || []);
        setClosed(!!r.data.closed);
      })
      .catch(() => {
        if (!alive) return;
        setSlots([]);
        setClosed(false);
      })
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [scope, date]);

  const placeholder = !date
    ? "Choisissez d'abord une date"
    : loading
      ? "Chargement..."
      : closed
        ? "Fermé ce jour"
        : slots.length === 0
          ? "Aucun horaire disponible"
          : "Choisir une heure";

  const allSlots =
    value && !slots.includes(value) ? [value, ...slots] : slots;

  return (
    <div>
      <select
        data-testid={testid}
        value={value}
        disabled={!forceEnabled && (!date || loading || closed || slots.length === 0)}
        onChange={(e) => onChange(e.target.value)}
        className={`${className} ${!value ? "text-[#102C1F]/40" : ""} disabled:opacity-50`}
      >
        <option value="">{placeholder}</option>
        {allSlots.map((s) => (
          <option key={s} value={s} disabled={allFull.includes(s)}>
            {fmtSlot(s)}
            {allFull.includes(s)
              ? " — Complet"
              : s in usage
                ? ` · ${usage[s]} ${usage[s] > 1 ? "réservées" : "réservée"}`
                : ""}
          </option>
        ))}
      </select>
      {date && closed && !forceEnabled && (
        <p
          data-testid={`${testid}-closed-hint`}
          className="mt-1.5 text-[11px] text-red-700/80"
        >
          Fermé ce jour — choisissez une autre date.
        </p>
      )}
    </div>
  );
}
